import wcbtWishList from './setting/wishlist';
import wcbtCompare from './setting/compare';
import wcbtQuickView from './setting/quick-view';
import wcbtVariation from './setting/variation';
import wcbtMaxSale from './setting/maxsale';
import wcbtSaleNotice from './setting/sale-notice';
import wcbtProductFilter from './setting/product-filter';
import wcbtCheckboxSortable from '../mixins/checkbox-sortable';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	wcbtCheckboxSortable();
	wcbtWishList();
	wcbtCompare();
	wcbtQuickView();
	wcbtVariation();
	wcbtMaxSale();
	wcbtSaleNotice();
	wcbtProductFilter();
} );
